import { createDeduplicate } from "./_common";
import { CubePoint } from "./CubePoint";
import { POLYGON_RADIUS } from "./Shape";
import { linearInterpolate } from "./_common";
import { OffsetPoint } from "./OffsetPoint";
import { Record, Set } from "immutable";
const AxialPointCtor = Record({ type: 'IAxialPoint', q: 0, r: 0 });
export var AxialPoint;
(function (AxialPoint) {
    AxialPoint.create = (pointOrQ, r) => AxialPointCtor((typeof pointOrQ === 'number')
        ? ({ q: pointOrQ, r: r })
        : pointOrQ);
    // Arithmetic
    AxialPoint.add = (p1, p2) => AxialPoint.create({
        q: p1.q + p2.q,
        r: p1.r + p2.r,
    });
    AxialPoint.negate = ({ q, r }) => AxialPoint.create({ q: -q, r: -r });
    AxialPoint.subtract = (p1, p2) => AxialPoint.add(p1, AxialPoint.negate(p2));
    // Conversions
    AxialPoint.toCubePoint = ({ q, r }) => CubePoint.create({ q, r, s: -q - r });
    AxialPoint.toOffsetPoint = ({ q, r }) => OffsetPoint.create({
        x: q,
        y: r + (q - (q & 1)) / 2,
    });
    AxialPoint.toPixelPoint = ({ q, r }) => ({
        x: POLYGON_RADIUS * (3 / 2 * q),
        y: POLYGON_RADIUS * ((Math.sqrt(3) / 2 * q) + (Math.sqrt(3) * r)),
    });
    // Constraints
    AxialPoint.round = (point) => CubePoint.toAxialPoint(CubePoint.round(AxialPoint.toCubePoint(point)));
    // Spatiality
    AxialPoint.getDistance = (p1, p2) => (CubePoint.getDistance(AxialPoint.toCubePoint(p1), AxialPoint.toCubePoint(p2)));
    AxialPoint.interpolateLinear = (p1, p2, percentile) => AxialPoint.create({
        q: linearInterpolate(p1.q, p2.q, percentile),
        r: linearInterpolate(p1.r, p2.r, percentile),
    });
    // Aggregation
    AxialPoint.allPointsWithinRange = (center, distance) => (Set([...CubePoint.allPointsWithinRange(AxialPoint.toCubePoint(center), distance)].map(CubePoint.toAxialPoint)));
    AxialPoint.toCacheKey = ({ q, r }, precision) => {
        const qKey = precision ? Math.round(q * Math.pow(10, precision)) : q;
        const rKey = precision ? Math.round(r * Math.pow(10, precision)) : r;
        return `${qKey}:${rKey}`;
    };
    AxialPoint.deduplicate = createDeduplicate(AxialPoint.toCacheKey);
    AxialPoint.pointsAlongLine = (p1, p2, opts = {}) => (Set([...CubePoint.pointsAlongLine(AxialPoint.toCubePoint(p1), AxialPoint.toCubePoint(p2), opts)].map(CubePoint.toAxialPoint)));
    AxialPoint.pointsAlongPixelLine = (p1, p2, opts = {}) => (Set([...CubePoint.pointsAlongPixelLine(p1, p2, opts)].map(CubePoint.toAxialPoint)));
})(AxialPoint || (AxialPoint = {}));
//# sourceMappingURL=AxialPoint.js.map